export const researchersList = [
    {
        id: 0,
        authorName: 'Yu Yu',
        affiliation: "Yu Yu is a Research Fellow and Strategic Investor at Contrimetric, a scholarly communication and research intelligence platform dedicated to enhancing the visibility, dissemination, and impact of academic research worldwide.\n Her research interests focus on:\n Bibliometrics, Scientometrics, Webometrics, Innovation Methods Research, Big Data Computing, Generative Computing. \n \n She is actively engaged in the development of data-driven methodologies for scholarly communication assessment, research evaluation, knowledge discovery, and academic publishing analytics. Her work explores the integration of bibliometric indicators, web-based scholarly impact metrics, artificial intelligence technologies, and large-scale data analysis to support evidence-based decision-making in research management and academic publishing. \n \n As a strategic investor of Contrimetric, she also contributes to the platform's long-term innovation strategy and the advancement of next-generation scholarly intelligence solutions.",
        img: require('@/assets/images/team/Yu.jpg'),
        profile: '',
        position: 'Research Fellow & Strategic Investor \n Contrimetric, Singapore',
        email: ""
    },
    {
        id: 1,
        authorName: 'PROF. Noorhidawati binti Abdullah',
        affiliation: 'Department of Library and Information Science, \nFaculty of Arts and Social Sciences, \nUniversity of Malaya, \nKuala Lumpur, \nMalaysia',
        img: require('@/assets/images/team/Abdullah.jpg'),
        profile: 'https://umexpert.um.edu.my/noorhidawati.html',
        position: 'Researcher',
        email: "",
        detail: {
            headerTitle: 'Professor Dr. Noorhidawati Abdullah',
            headerSubtitle: 'Professor, Department of Library and Information Science, Faculty of Arts and Social Sciences, Universiti Malaya, Malaysia / Chief Editor, Malaysian Journal of Library and Information Science (MJLIS)',
            researchInterests: [
                'Bibliometrics and Scientometrics',
                'Scholarly Communication',
                'Open Science',
                'Research Data Management',
                'Digital Libraries',
                'Information Behavior',
                'Information Retrieval',
                'Research Evaluation'
            ],
            professionalProfile: [
                'Professor Dr. Noorhidawati Abdullah is one of Malaysia\'s leading scholars in Library and Information Science. She is a Professor at Universiti Malaya and serves as Chief Editor of the Malaysian Journal of Library and Information Science (MJLIS), a leading journal indexed in Web of Science and Scopus. She has extensive experience in scholarly communication, bibliometric research, digital libraries, research data management, and open science.',
                'Since joining Universiti Malaya in 2008, Professor Noorhidawati has held numerous academic leadership positions, including Head of the Department of Library and Information Science. She is widely recognized for her contributions to scientometrics, research evaluation, journal quality assessment, and open science capacity building.'
            ],
            researchProjects: [
                {
                    title: 'Open Science and Research Data Management Programs',
                    role: 'Principal Investigator and Research Leader'
                },
                {
                    title: 'Scholarly Communication and Research Evaluation Studies',
                    role: 'Principal Investigator'
                },
                {
                    title: 'Digital Libraries and Information Behavior Research',
                    role: 'Principal Investigator'
                },
                {
                    title: 'Bibliometric and Scientometric Analysis Projects',
                    role: 'Research Leader'
                },
                {
                    title: 'National Journal Evaluation and MyCite Assessment Programs',
                    role: 'Subject Matter Expert'
                }
            ],
            publications: [
                {
                    group: '',
                    items: [
                        'Investigating the Influence of Factors Affecting Medical Journal Submission Intention. Journal of Information Science.',
                        'Developing and Prioritizing a Research Data Management Capability Framework for Research Institutions. The Electronic Library.',
                        'Investigating Key Areas and Practices for Research Data Management in Research Institutions. Information Development.',
                        'The Cautious Faculty: Malaysian University Researchers\' Awareness, Experiences and Attitudes Towards Open Peer Review. Malaysian Journal of Library and Information Science.',
                        'LIS Journals Categorization in the Journal Citation Reports. Scientometrics.',
                        'How Do Young Children Engage with Mobile Apps? Computers & Education.',
                        'How Students Use E-Books: Reading or Referring? Malaysian Journal of Library and Information Science.'
                    ]
                }
            ],
            academicService: [
                {
                    group: 'Editorial Leadership',
                    items: [
                        'Chief Editor, Malaysian Journal of Library and Information Science (MJLIS)',
                        'Editorial Board Member, Public Library Quarterly'
                    ]
                },
                {
                    group: 'Professional Memberships',
                    items: [
                        'International Society for Scientometrics and Informetrics (ISSI)',
                        'Association for Information Science and Technology (ASIS&T)'
                    ]
                },
                {
                    group: 'Academic Leadership',
                    items: [
                        'Former Head, Department of Library and Information Science',
                        'National Expert for MyCite Scientific Journal Evaluation'
                    ]
                }
            ],
            honors: [
                'Excellence Service Awards, Universiti Malaya',
                'Best Paper Awards in Library and Information Science Conferences',
                'National Recognition in Scholarly Communication and Journal Evaluation'
            ]
        }
    },
    {
        id: 2,
        authorName: 'Asssociate PROF. Yanti Idaya Aspura binti Mohd Khalid',
        affiliation: 'Department of Library and Information Science, \nFaculty of Arts and Social Sciences, \nUniversity of Malaya, \nKuala Lumpur, \nMalaysia',
        img: require('@/assets/images/team/Yanti.jpg'),
        profile: 'https://umexpert.um.edu.my/yanti.html',
        position: 'Researcher',
        email: "",
        detail: {
            headerTitle: 'Associate Professor Dr. Yanti Idaya Aspura Mohd Khalid',
            headerSubtitle: 'Dean, Faculty of Arts and Social Sciences / Associate Professor, Department of Library and Information Science, Universiti Malaya, Malaysia',
            researchInterests: [
                'Research Data Management',
                'Open Science',
                'Data Stewardship',
                'Scholarly Communication',
                'Bibliometrics and Scientometrics',
                'Digital Libraries',
                'Information Management',
                'Knowledge Organization'
            ],
            professionalProfile: [
                'Associate Professor Dr. Yanti Idaya Aspura Mohd Khalid is the Dean of the Faculty of Arts and Social Sciences at Universiti Malaya and a distinguished scholar in Library and Information Science. Her academic expertise focuses on research data management, open science, scholarly communication, digital libraries, and bibliometric analysis. Prior to joining Universiti Malaya, she served for more than a decade as a Senior Librarian at the International Islamic University Malaysia.',
                'Dr. Yanti has played a leading role in advancing open science and data stewardship initiatives in Malaysia. She is actively involved in research and policy development related to research data governance, scholarly communication, and digital information management.'
            ],
            researchProjects: [
                {
                    title: 'Knowledge Representation Using Ontology-Based Social Semantic for Malay Manuscript Digital Library Collection',
                    grant: 'Fundamental Research Grant Scheme (FRGS)',
                    role: 'Principal Investigator'
                },
                {
                    title: 'Open Science and Research Data Management Initiatives',
                    role: 'Research Leader and Working Group Member'
                },
                {
                    title: 'University of Malaya Open Science Programs',
                    role: 'Task Force Member'
                },
                {
                    title: 'Data Stewardship and Scholarly Communication Research',
                    role: 'Principal Investigator'
                }
            ],
            publications: [
                {
                    group: '',
                    items: [
                        'Tradition Meets Innovation: Research Trends in Libraries, Archives and Museums Convergence from a Digital Humanities Perspective. Knowledge Organization.',
                        'Navigating Data Visualization: Service Landscapes and Librarian Roles in Academic Libraries. The Electronic Library.',
                        'Trends and Changes in Academic Libraries\' Data Management Functions. Journal of Academic Librarianship.',
                        'Developing Research Data Management Frameworks for Research Institutions. The Electronic Library.',
                        'Current Landscape of Open Educational Resources Initiatives by Malaysian Academic Libraries. Malaysian Journal of Library and Information Science.'
                    ]
                }
            ],
            academicService: [
                {
                    group: 'Editorial Boards',
                    items: [
                        'Editorial Board Member, Malaysian Journal of Library & Information Science (MJLIS)'
                    ]
                },
                {
                    group: 'Professional Activities',
                    items: [
                        'Certified Data Steward',
                        'Member of national Open Science initiatives',
                        'Research Data Management and Open Science advocate'
                    ]
                }
            ],
            honors: [
                'Certified Data Steward (CDS)',
                'Academic Leadership Award, Universiti Malaya',
                'Multiple national grants and research awards in Library and Information Science'
            ]
        }
    },
    {
        id: 3,
        authorName: 'Dr. Zhenfeng Liu',
        affiliation: `Doctor of Engineering, \nAssociate Professor, Doctoral supervisor / Master's supervisor, \nSchool of Economics and Management, \nShanghai Maritime University`,
        img: require('@/assets/images/team/Lzf.png'),
        profile: 'https://sem.shmtu.edu.cn/2020/1126/c7782a35245/page.htm',
        position: 'Researcher',
        email: "",
        detail: {
            headerTitle: 'Prof. Zhenfeng Liu, Ph.D.',
            headerSubtitle: 'Professor and Doctoral Supervisor / School of Economics and Management / Shanghai Maritime University, China',
            researchInterests: [
                'Supply Chain Innovation and Resilience',
                'Innovation Management',
                'Complex Network Analysis',
                'Patent Analytics and Technology Opportunity Discovery',
                'Intelligent Data Analytics',
                'Maritime Industry Innovation',
                'Engineering Management'
            ],
            professionalProfile: [
                'Prof. Zhenfeng Liu is a Professor and Doctoral Supervisor at the School of Economics and Management, Shanghai Maritime University. His research focuses on innovation management, supply chain innovation, complex network analysis, patent analytics, and technology opportunity identification. He has developed interdisciplinary approaches that integrate network science, artificial intelligence, and innovation studies to address challenges in manufacturing, logistics, maritime industries, and technology management.',
                'Prof. Liu has published extensively in leading international journals, including Technovation, Technological Forecasting and Social Change, IEEE Transactions on Engineering Management, Advanced Engineering Informatics, and Computers & Industrial Engineering. He has also led multiple national and provincial research projects and holds numerous authorized patents.'
            ],
            researchProjects: [
                {
                    title: 'Key Technology Breakthroughs and Resilience Enhancement of the Offshore Equipment Industry Chain',
                    grant: 'National Social Science Fund of China (General Project)',
                    role: 'Principal Investigator'
                },
                {
                    title: 'Disruptive Innovation Paths of Chinese Complex Product System Manufacturing Enterprises under Latecomer Conditions',
                    grant: 'Humanities and Social Sciences Fund of the Ministry of Education',
                    role: 'Principal Investigator'
                },
                {
                    title: 'Innovation Methods in the Fuzzy Front End of Product Development in China',
                    grant: 'National Innovation Method Program',
                    role: 'Principal Investigator'
                },
                {
                    title: 'Technology Bottlenecks and Disruptive Innovation in China\'s Deep-Sea Low-Carbon Energy Sector',
                    grant: 'Shanghai Soft Science Research Program',
                    role: 'Principal Investigator'
                }
            ],
            publications: [
                {
                    group: 'Journal Articles',
                    items: [
                        'Liu, Z., et al. (2026). From Technology Hierarchies to Convergence Prediction: Integrating Graph Learning into Multi-Layer Heterogeneous Networks. Advanced Engineering Informatics, 69(B), 103927.',
                        'Liu, Z., et al. (2025). Firm-Specific Patent Recommendation Using Topology-Based Link Prediction and SAO Embedding Method. IEEE Transactions on Engineering Management, 72, 2097–2115.',
                        'Liu, Z., et al. (2025). Identifying Supply Chain R&D Partners via Multilayer Institutional Cooperation Network and Tailored Link Prediction. Computers & Industrial Engineering, 201, 110887.',
                        'Liu, Z., et al. (2023). Technology Opportunity Analysis Using Hierarchical Semantic Networks and Dual Link Prediction. Technovation, 128, 102872.',
                        'Liu, Z., et al. (2023). From Technology Opportunities to Ideas Generation via Cross-Cutting Patent Analysis: Application of Generative Topographic Mapping and Link Prediction. Technological Forecasting and Social Change, 192, 122565.',
                        'Liu, Z., et al. (2022). Technology Opportunity Discovery Based on Patent Knowledge Networks and Link Prediction: A Case Study in Advanced Manufacturing. Technological Forecasting and Social Change.',
                        'Liu, Z., et al. (2021). Patent-Based Technology Opportunity Identification and Innovation Path Analysis Using Complex Network Methods. Scientometrics.'
                    ]
                }
            ],
            academicService: [
                {
                    group: 'Journal Reviewer',
                    items: [
                        'Technovation',
                        'Technological Forecasting and Social Change',
                        'IEEE Transactions on Engineering Management',
                        'Scientometrics',
                        'Creativity and Innovation Management',
                        'Technology Analysis & Strategic Management',
                        'Research Management',
                        'Management Review'
                    ]
                },
                {
                    group: 'Professional Activities',
                    items: [
                        'Expert Reviewer for national and provincial research evaluation programs',
                        'Active contributor to innovation management and technology forecasting communities',
                        'Holder of multiple authorized patents in innovation and engineering-related fields'
                    ]
                }
            ],
            honors: [
                'National Coal Industry Youth Science and Technology Award',
                'First Prize, Henan Provincial Science and Technology Progress Award',
                'Young Talent Support Program, Henan Association for Science and Technology'
            ]
        }
    }
]
